// extracted by mini-css-extract-plugin
export default {"PropertySpyItemDetailChangeListTable":"PropertySpyItemDetailChangeListTable_PropertySpyItemDetailChangeListTable__k+swj"};